module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn",
    attrs: {
      "id": "open-licence-modal",
      "hide-header": false,
      "title": _vm.$t('not_support_prime.title'),
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [_c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('not_support_prime.description'))
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adf46684","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LicenceModal.vue
// module id = 1604
// module chunks = 1